import { injectable } from 'inversify';
import { RectangleArea } from '@fantasmagames/core/src/geom/RectangleArea';
import { Device } from '@fantasmagames/core/src/device/Device';

@injectable()
export class ResolutionManager {
	public static readonly MOBILE_TO_DESKTOP_FRACTIONAL: number = 1080 / 1280;
	public static readonly DESKTOP_TO_MOBILE_FRACTIONAL: number = 1280 / 1080;

	private _resolution: RectangleArea;
	private _halfResolution: RectangleArea;
	private _viewportResolution: PIXI.Point;
	private _defaultViewportResolution: PIXI.Point;

	private _device: Device;

	public constructor(viewport: RectangleArea, device: Device) {
		if (device.desktop) {
			this._resolution = new RectangleArea(1920, 1080);
			this._halfResolution = new RectangleArea(960, 540);
		} else {
			this._resolution = new RectangleArea(720, 1280);
			this._halfResolution = new RectangleArea(360, 640);
		}

		this._device = device;

		this.initViewPortResolution(viewport);
	}

	public updateViewPortResolution(x: number, y: number): void {
		this._viewportResolution = new PIXI.Point(x, y);
	}

	private initViewPortResolution(viewport: RectangleArea): void {
		this._viewportResolution = new PIXI.Point(this._resolution.width / viewport.width, this._resolution.height / viewport.height);
		this._defaultViewportResolution = this._viewportResolution.clone();
	}

	public get defaultViewportResolution(): PIXI.Point {
		return this._defaultViewportResolution;
	}

	public get resolution(): RectangleArea {
		return this._resolution;
	}

	public get halfResolution(): RectangleArea {
		return this._halfResolution;
	}

	public get viewportResolution(): PIXI.Point {
		return this._viewportResolution;
	}

	public get mobToPcFractional(): number {
		return ResolutionManager.MOBILE_TO_DESKTOP_FRACTIONAL;
	}

	public get pcToMobFractional(): number {
		return ResolutionManager.DESKTOP_TO_MOBILE_FRACTIONAL;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/screen/ResolutionManager.ts